import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError, getControl, getGroup } from '@shared/helpers/form.helper';
import { toNum } from '@shared/helpers/math.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { IMPORTO_SUPERIORE_10_33_ERROR, INCONSISTENT_VALUE, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { getContribLegge59Control } from './helpers/contrib-legge-59-92-form.helpers';
import { isEqual } from 'lodash-es';
import { formPaths } from '@shared/constants/form-paths.const';
import { isAfter } from 'date-fns';

export const contribLegge59VersamentiRules: FormGroupRules = {
    my_ImportoComplessivo: (form: FormGroup) => {
        const my_ImportoComplessivoControl = getContribLegge59Control(form, 'my_ImportoComplessivo');
        const my_ImportoComplessivo: string = getContribLegge59Control(form, 'my_ImportoComplessivo')?.value;
        const errors = my_ImportoComplessivoControl.errors ? my_ImportoComplessivoControl.errors : {};

        addRemoveError(isNilOrEmpty(my_ImportoComplessivo), errors, 'my_ImportoComplessivo', {
            status: REQUIRED_STATUS,
        });

        my_ImportoComplessivoControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ImportoVersato: (form: FormGroup) => {
        const my_ImportoVersatoControl = getContribLegge59Control(form, 'my_ImportoVersato');
        const my_ImportoVersato = toNum(my_ImportoVersatoControl?.value);
        const my_ImportoComplessivo = toNum(getContribLegge59Control(form, 'my_ImportoComplessivo')?.value);
        const errors = my_ImportoVersatoControl.errors ? my_ImportoVersatoControl.errors : {};

        addRemoveError(isNilOrEmpty(my_ImportoVersato) && my_ImportoComplessivo >= 10.33, errors, 'my_ImportoVersato', {
            status: IMPORTO_SUPERIORE_10_33_ERROR,
        });

        addRemoveError(toNum(my_ImportoVersato) < 0, errors, 'my_ImportoVersato', {
            status: INCONSISTENT_VALUE,
        });

        my_ImportoVersatoControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ImportoVersatoAnno1: (form: FormGroup) => {
        const datiBilancioGroup = getGroup(form, formPaths.datiBilancio);
        const my_ImportoVersatoAnno1Control = getContribLegge59Control(form, 'my_ImportoVersatoAnno1');
        const my_ImportoComplessivoAnno1 = toNum(getContribLegge59Control(form, 'my_ImportoComplessivoAnno1')?.value);
        const my_DataApprovazione1: string = getControl(datiBilancioGroup, 'my_DataApprovazione1')?.value;
        const my_TipoSchemaBil1: string = getControl(datiBilancioGroup, 'my_TipoSchemaBil1')?.value;
        const my_BilancioAllegato: string = getControl(form, `${formPaths.bilancio}.my_BilancioAllegato`)?.value;
        const showInconsistentError =
            toNum(my_ImportoVersatoAnno1Control?.value) < 0 && !isNilOrEmpty(my_DataApprovazione1) && !isNilOrEmpty(my_TipoSchemaBil1) && !isNilOrEmpty(my_BilancioAllegato);
        const errors = my_ImportoVersatoAnno1Control.errors ? my_ImportoVersatoAnno1Control.errors : {};

        addRemoveError(isNilOrEmpty(my_ImportoVersatoAnno1Control?.value) && my_ImportoComplessivoAnno1 >= 10.33, errors, 'my_ImportoVersatoAnno1', {
            status: IMPORTO_SUPERIORE_10_33_ERROR,
        });

        addRemoveError(showInconsistentError, errors, 'my_ImportoVersatoAnno1', {
            status: INCONSISTENT_VALUE,
        });

        my_ImportoVersatoAnno1Control.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_DataVersam: (form: FormGroup) => {
        dataVersamentoHelper(form, 'my_DataVersam', 'my_ImportoVersato');
    },

    my_DataVersamAnno1: (form: FormGroup) => {
        dataVersamentoHelper(form, 'my_DataVersamAnno1', 'my_ImportoVersatoAnno1');
    },

    my_CkTipoFondoBen: (form: FormGroup) => {
        ckTipoFondoBenHelper(form, 'my_CkTipoFondoBen', 'my_ImportoVersato', 'my_FondoBeneficiario');
    },

    my_CkTipoFondoBenAnno1: (form: FormGroup) => {
        ckTipoFondoBenHelper(form, 'my_CkTipoFondoBenAnno1', 'my_ImportoVersatoAnno1', 'my_FondoBeneficiarioAnno1');
    },

    my_FondoBeneficiario: (form: FormGroup) => {
        fondoBeneficiarioHelper(form, 'my_FondoBeneficiario', 'my_ImportoVersato');
    },

    my_FondoBeneficiarioAnno1: (form: FormGroup) => {
        fondoBeneficiarioHelper(form, 'my_FondoBeneficiarioAnno1', 'my_ImportoVersatoAnno1');
    },

    my_CkVersamEffett: (form: FormGroup) => {
        const datiBilancioGroup = getGroup(form, formPaths.datiBilancio);
        const idAssegnazione: string = getControl(form, 'my_IdAssegnazione')?.value;
        const my_CkVersamEffettControl = getContribLegge59Control(form, 'my_CkVersamEffett');
        const my_CkVersamEffett: string = my_CkVersamEffettControl?.value;
        const my_ImportoComplessivo = toNum(getContribLegge59Control(form, 'my_ImportoComplessivo')?.value);
        const my_ImportoComplessivoAnno1 = toNum(getContribLegge59Control(form, 'my_ImportoComplessivoAnno1')?.value);
        const my_ImportoVersatoAnno1 = toNum(getContribLegge59Control(form, 'my_ImportoVersatoAnno1')?.value);
        const my_CkTipoFondoBenAnno1: string = getContribLegge59Control(form, 'my_CkTipoFondoBenAnno1')?.value;
        const my_DataCompilaz = new Date(getControl(form, 'my_SezioneI__Rilevazione.my_Conclusioni.my_DataCompilaz')?.value);
        const my_DataApprovazione1_60 = new Date(getControl(datiBilancioGroup, 'my_DataApprovazione1_60')?.value);
        const my_ImportoVersato = toNum(getContribLegge59Control(form, 'my_ImportoVersato')?.value);
        const my_DataApprovazione2_60 = new Date(getControl(datiBilancioGroup, 'my_DataApprovazione2_60')?.value);
        const my_CkTipoFondoBen: string = getContribLegge59Control(form, 'my_CkTipoFondoBen')?.value;
        const showRequiredError = isNilOrEmpty(my_CkVersamEffett) && (my_ImportoComplessivo > 10.33 || my_ImportoComplessivoAnno1 > 10.33);
        const checkVersamentoFn = (importoComplessivo: number, importoVersato: number, dataApprovazione: Date, ckTipoFondo: string) => {
            return (
                my_CkVersamEffett === '1' &&
                importoComplessivo >= 10.33 &&
                Math.floor(importoComplessivo) > Math.floor(importoVersato) &&
                isAfter(my_DataCompilaz, dataApprovazione) &&
                ckTipoFondo !== '1' &&
                idAssegnazione !== '291307' &&
                idAssegnazione !== '299752'
            );
        };
        const showVersamentoError =
            checkVersamentoFn(my_ImportoComplessivoAnno1, my_ImportoVersatoAnno1, my_DataApprovazione1_60, my_CkTipoFondoBenAnno1) ||
            checkVersamentoFn(my_ImportoComplessivo, my_ImportoVersato, my_DataApprovazione2_60, my_CkTipoFondoBen);
        const errors = my_CkVersamEffettControl.errors ? my_CkVersamEffettControl.errors : {};

        addRemoveError(showRequiredError, errors, 'my_CkVersamEffett', {
            status: REQUIRED_STATUS,
        });

        addRemoveError(showVersamentoError, errors, 'my_CkVersamEffett', {
            status: 'Attenzione: La cooperativa non ha versato correttamente il 3%',
        });

        my_CkVersamEffettControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_RicevutaPagamento: (form: FormGroup) => {
        ricevutaPagamentoHelper(form, 'my_RicevutaPagamento', 'my_ImportoVersato', false);
    },

    my_RicevutaPagamentoAnno1: (form: FormGroup) => {
        ricevutaPagamentoHelper(form, 'my_RicevutaPagamentoAnno1', 'my_ImportoVersatoAnno1', true);
    },
};

const dataVersamentoHelper = (form: FormGroup, targetPath: string, importoVersatoPath: string) => {
    const targetControl = getContribLegge59Control(form, targetPath);
    const importVersato = toNum(getContribLegge59Control(form, importoVersatoPath)?.value);
    const errors = targetControl.errors ? targetControl.errors : {};

    addRemoveError(isNilOrEmpty(targetControl?.value) && importVersato > 0, errors, targetPath, {
        status: "Il campo deve essere inserito obbligatoriamente perchè c'è un importo versato",
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};

const ckTipoFondoBenHelper = (form: FormGroup, targetPath: string, importoVersatoPath: string, fondoBeneficiarioPath: string) => {
    const targetControl = getContribLegge59Control(form, targetPath);
    const importVersato = toNum(getContribLegge59Control(form, importoVersatoPath)?.value);
    const fondoBeneficiario: string = getContribLegge59Control(form, fondoBeneficiarioPath)?.value;
    const errors = targetControl.errors ? targetControl.errors : {};

    addRemoveError(isNilOrEmpty(targetControl?.value) && importVersato > 0, errors, targetPath, {
        status: REQUIRED_STATUS,
    });

    addRemoveError(targetControl?.value !== '1' && fondoBeneficiario?.includes('MiSE'), errors, targetPath, {
        status: 'Attenzione indicare SI se il MiSE è tra i fondi beneficiari',
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};

const fondoBeneficiarioHelper = (form: FormGroup, targetPath: string, importoVersatoPath: string) => {
    const targetControl = getContribLegge59Control(form, targetPath);
    const importVersato = toNum(getContribLegge59Control(form, importoVersatoPath)?.value);
    const errors = targetControl.errors ? targetControl.errors : {};

    addRemoveError(isNilOrEmpty(targetControl?.value) && importVersato > 0, errors, targetPath, {
        status: "Il campo deve essere inserito obbligatoriamente in quanto c'è stato un versamento.",
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};

const ricevutaPagamentoHelper = (form: FormGroup, targetPath: string, importoVersatoPath: string, isFirstYear: boolean) => {
    const targetControl = getContribLegge59Control(form, targetPath);
    const importVersato = toNum(getContribLegge59Control(form, importoVersatoPath)?.value);
    const my_ObbligoAllegatoRicev3perc: string = getContribLegge59Control(form, 'my_ObbligoAllegatoRicev3perc')?.value;
    const obbligoArray = my_ObbligoAllegatoRicev3perc?.split('-') || [];
    const errors = targetControl.errors ? targetControl.errors : {};

    if (obbligoArray?.length === 2) {
        const obbligoCheckValue = isFirstYear ? obbligoArray[1] : obbligoArray[0];
        addRemoveError(isNilOrEmpty(targetControl?.value) && importVersato > 0 && obbligoCheckValue === 'S', errors, targetPath, {
            status: 'Allegare la ricevuta di pagamento',
        });
    } else {
        addRemoveError(false, errors, targetPath, {
            status: 'Allegare la ricevuta di pagamento',
        });
    }

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};
